export class GoToTextTabEvent {}
